e4.product = {
    debug: false,
    init: function () {
        if ( jQuery( '.js-e-product-form, .js-e-productlist' ).length > 0 ) {
            e4.require.js( e4.settings.require.jQueryValidate, function () {
                e4.product.bindEvents();
                e4.product.variants.init();
            } );
        }
    },
    bindEvents: function () {
        jQuery( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
            e4.product.validateForm( domForm );
        } );
        jQuery( '.js-e-productlist' ).on( 'builded.e4.productlist', function ( event ) {
            jQuery( event.target ).find( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
                e4.product.validateForm( domForm );
            } );
        } );
        jQuery( '.js-e-product-images, #js-e-product-image-modal' ).on( 'loaded.e4.jsonpublisher', '.js-e-jsonpublisher', function ( event ) {
            jQuery( event.target ).on( 'mouseenter', '.carousel-indicators li', function ( event ) {
                jQuery( event.target ).trigger( 'click' );
            } );
        } );
        jQuery( '.js-e-product-images' ).find( '.js-e-jsonpublisher' ).on( 'load.e4.jsonpublisher', function ( event ) {
            jQuery( event.target ).addClass( 'is-loading' );
        } ).on( 'loaded.e4.jsonpublisher', function ( event ) {
            jQuery( event.target ).removeClass( 'is-loading' );
        } );
    },
    validateForm: function ( domForm ) {
        var jForm = jQuery( domForm );
        jForm.validate( {
            submitHandler: function ( domForm ) {
                if ( jForm.is( '.js-e-product-form-removefromcart' ) === true ) {
                    e4.product.removeFromCart( domForm );
                }
                else /* if ( jForm.is( '.js-e-product-form-addtocart' ) === true )*/ {
                    e4.product.addToCart( domForm );
                }
            }
        } );
    },
    addToCart: function ( domForm ) {
        var jForm = jQuery( domForm ),
            arrFormData = jForm.serializeArray(),
            objFormData = {};
        for ( var i = 0; i < arrFormData.length; i++ ) {
            objFormData[ arrFormData[ i ].name ] = arrFormData[ i ].value;
        }
        jQuery.extend( objFormData, {
            Redirect: false
        } );
        if ( jForm.is( '.js-e-product-form-download' ) === true ) {
            e4.download.cart.addProduct( objFormData );
        }
        else {
            e4.cart.addProduct( objFormData );
        }
    },
    removeFromCart: function ( domForm ) {
        var jForm = jQuery( domForm ),
            arrFormData = jForm.serializeArray(),
            objFormData = {};
        for ( var i = 0; i < arrFormData.length; i++ ) {
            objFormData[ arrFormData[ i ].name ] = arrFormData[ i ].value;
        }
        jQuery.extend( objFormData, {
            Redirect: false
        } );
        if ( jForm.is( '.js-e-product-form-download' ) === true ) {
            e4.download.cart.removeProduct( objFormData );
        }
        else {
            e4.cart.removeProduct( objFormData );
        }
    }
};
